import { QueryClient } from '@tanstack/react-query';

/**
 * Configuration globale du QueryClient pour React Query
 *
 * Paramètres optimisés pour connexions lentes:
 * - Cache agressif pour réduire les requêtes réseau
 * - Retry automatique avec exponential backoff
 * - Pas de refetch sur window focus (économise bande passante)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache les données pendant 5 minutes
      staleTime: 5 * 60 * 1000,

      // Garde les données en cache pendant 30 minutes après qu'elles soient "stale"
      cacheTime: 30 * 60 * 1000,

      // Ne pas refetch automatiquement quand la fenêtre reprend le focus
      // (économise de la bande passante sur connexions lentes)
      refetchOnWindowFocus: false,

      // Retry 3 fois en cas d'échec
      retry: (failureCount, error) => {
        // Ne pas retry sur les erreurs client (4xx)
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }

        // Retry maximum 3 fois pour erreurs réseau/serveur
        return failureCount < 3;
      },

      // Exponential backoff avec max 30s
      // Tentative 1: 1s, Tentative 2: 2s, Tentative 3: 4s, max: 30s
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },

    mutations: {
      // Retry 2 fois pour les mutations (plus conservateur)
      retry: (failureCount, error) => {
        // Ne pas retry sur erreurs client
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }

        return failureCount < 2;
      },

      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
    },
  },
});
